import { Component, OnInit, ViewChild } from '@angular/core';

import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

import { FormatService, HelperService, HTTPService } from 'app/services';
import { config, messages } from 'app/constants';

import { find, findIndex } from 'lodash';

import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-canned-inspection-add',
  templateUrl: './canned-inspection-add.component.html',
  styleUrls: ['./canned-inspection-add.component.scss'],
})
export class CannedInspectionAddComponent implements OnInit {
  @ViewChild('cannedInspectionAddBody', { static: true })
  cannedInspectionAddBody;

  categories: any[] = [];
  cannedInspection: any = {
    _id: '',
    title: '',
    categories: [],
  };
  selectedCategoryInspection: any[] = [];
  cannedInspectionCategories: any[] = [];
  isEditMode: boolean = false;
  errors: any = {};
  isProcessing: boolean = false;
  dragDisabled = true;
  cannedInspectionId: string = '';
  activityLogs: any = [];
  selectedTab = 0;
  
  constructor(
    private httpService: HTTPService,
    private formatService: FormatService,
    private dynamicDialogRef: DynamicDialogRef,
    private helperService: HelperService,
    private dialogConfig: DynamicDialogConfig
  ) {}

  ngOnInit() {
    this.getTagList();

    const data = this.helperService.deepCopy(this.dialogConfig.data);

    if (data && data.cannedInspectionId) {
      this.isEditMode = true;
      
      this.httpService.getInspectionById(data.cannedInspectionId).then(
        (cannedInspection: any) => {
          this.cannedInspection = cannedInspection;
          this.cannedInspection.categories =
            this.cannedInspection.category || {};

          if (
            this.cannedInspection.category &&
            this.cannedInspection.category.length
          ) {
            this.selectedCategoryInspection = this.helperService.deepCopy(
              this.cannedInspection.category
            );
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      );
      this.cannedInspectionId = data.cannedInspectionId;
      this.getLogs();
    }
  }
  
  getLogs() {
    const query = <any>{};
    query.entityId = this.cannedInspectionId;
    this.httpService.getActivityLog(query).then(
      (data: any) => {
        if(data) {
          this.activityLogs = this.formatService.formateCatlogActivityLogs(data);
        }
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  handleFocus(name: string) {
    this.errors[name] = '';
  }

  getTagList() {
    this.httpService.getTags(config.tags.inspection).then(
      (categories: any[]) => {
        this.categories = categories;
      },
      (err) => {
        this.helperService.showToaster('error', err);
      }
    );
  }

  drop(event: CdkDragDrop<string[]>) {
    this.dragDisabled = true;
    if (event.previousContainer.id === event.container.id) {
      if (event.currentIndex !== this.cannedInspection.categories.length - 1) {
        moveItemInArray(
          this.cannedInspection.categories,
          event.previousIndex,
          event.currentIndex
        );
        // this.updateService();
      } else if (event.currentIndex === this.cannedInspection.categories.length - 1) {
        moveItemInArray(
          this.cannedInspection.categories,
          event.previousIndex,
          event.currentIndex - 1
        );
        // this.updateService();
      }
    }
  }

  handleChange(value: string) {
    this.cannedInspection.title = value;
  }

  handleSelectChange(event: any, catIndex: number) {
    const { list } = event;
    const inspectionItemIds = list.map(({ itemId }) => itemId);

    this.selectedCategoryInspection[catIndex].inspectionItems.forEach(
      (inspectionItem: any) => {
        inspectionItem.isChecked =
          inspectionItemIds.indexOf(inspectionItem.itemId) !== -1;
      }
    );
  }

  handleAllSelectChange(event: any, catIndex: number) {
    const { list } = event;
    const inspectionItemIds = list.map(({ itemId }) => itemId);

    this.selectedCategoryInspection[catIndex].inspectionItems.forEach(
      (inspectionItem: any) => {
        inspectionItem.isChecked =
          inspectionItemIds.indexOf(inspectionItem.itemId) !== -1;
      }
    );
  }

  populateCannedInspection(category: any) {
    this.httpService
      .getItemsByCategory(config.tags.inspection, category._id)
      .then(
        (item: any[]) => {
          if (item && item.length) {
            this.setCannedInspection(category, item);
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      );
  }

  /**
   * @todo need to improved more
   */
  setCannedInspection(category: any, ins: any) {
    const inspections = ins.map((item: any) => ({
      itemId: item._id,
      title: item.title,
      description: item.notes,
      isChecked: true,
    }));

    if (this.isEditMode) {
      const index = findIndex(this.cannedInspection.categories, {
        categoryId: category._id,
      });
      if (index >= 0) {
        const cat = this.cannedInspection.categories[index];
        this.cannedInspection.categories[index] = {
          ...cat,
          inspectionItems: [...inspections],
        };
        return;
      }
    }

    this.cannedInspection.categories.push({
      title: category.name,
      categoryId: category._id,
      inspectionItems: inspections,
    });
    this.selectedCategoryInspection.push({
      title: category.name,
      categoryId: category._id,
      inspectionItems: inspections,
    });
  }

  onSelect(insCategory: any) {
    if (this.isEditMode) {
      this.populateCannedInspection(insCategory);
    } else {
      const array = this.cannedInspection.categories.filter(
        (category) => category.categoryId === insCategory._id
      );
      if (array.length === 0) {
        this.populateCannedInspection(insCategory);
      } else {
        this.helperService.showToaster('error', 'Category already added!');
      }
    }
  }

  renderSelectItemText(data: any) {
    const { selectedCount } = data;
    return `${selectedCount} selected`;
  }

  scrollToBottom() {
    setTimeout(() => {
      try {
        this.cannedInspectionAddBody.nativeElement.scrollTop = this.cannedInspectionAddBody.nativeElement.scrollHeight;
      } catch (err) {}
    }, 100);
  }

  close(type?: boolean) {
    this.dynamicDialogRef.close(type);
  }

  handleDeleteAccordian(event) {
    const { index, data } = event;
    this.selectedCategoryInspection.splice(index, 1);
    this.cannedInspection.categories.splice(index, 1);
  }

  handleDragDisabled() {
    this.dragDisabled = false;
  }

  /**
   * @todo need to improved more
   */
  handleSubmit() {
    this.cannedInspection.title = this.cannedInspection.title?.trim()
    if (!this.cannedInspection.title) {
      this.helperService.showToaster('error', 'Title is required');
      this.errors.title = '';
    }

    if (!this.selectedCategoryInspection.length) {
      this.helperService.showToaster('error', 'Category is required');
    }

    if (this.cannedInspection.title && this.selectedCategoryInspection.length) {
      let count = 0;

      this.selectedCategoryInspection.forEach((category, index) => {
        if (category.inspectionItems && category.inspectionItems.length > 0) {
          count += category.inspectionItems.filter(({ isChecked }) => isChecked)
            .length;
        }
      });

      if (this.isEditMode) {
        if (this.isProcessing) {
          return;
        }
        this.isProcessing = true;
        let itemCount = 0;
        this.cannedInspection.categories.forEach((category, categoryIndex) => {
          itemCount += category.inspectionItems.filter(
            ({ isChecked }) => isChecked
          ).length;
        });
        this.httpService
          .updateInspection({
            title: this.cannedInspection.title,
            category: this.cannedInspection.categories,
            count: itemCount,
            _id: this.cannedInspection._id,
          })
          .then(
            (res) => {
              this.isProcessing = false;
              this.close(true);
              this.helperService.showToaster(
                'success',
                messages.cannedInspectionCreated
              );
            },
            (err) => {
              this.isProcessing = false;

              if (err.nonUnique) {
                this.errors.title = err.msg;
                this.helperService.showToaster('error', err.msg);
              } else {
                this.helperService.showToaster('error', err);
              }
            }
          );
      } else {
        if (this.isProcessing) {
          return;
        }
        this.isProcessing = true;
        this.httpService
          .createInspection({
            title: this.cannedInspection.title,
            category: this.selectedCategoryInspection,
            count,
          })
          .then(
            (res) => {
              this.isProcessing = false;
              this.close(true);
              this.helperService.showToaster(
                'success',
                messages.cannedInspectionCreated
              );
            },
            (err) => {
              this.isProcessing = false;

              if (err.nonUnique) {
                this.errors.title = err.msg;
                this.helperService.showToaster('error', err.msg);
              } else {
                this.helperService.showToaster('error', err);
              }
            }
          );
      }
    }
  }
}
